import React from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'material-ui/AutoComplete';
import FieldTitle from 'components/aor/FieldTitle';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class RenderAutoCompleteInputField extends React.Component {
    handleNewRequest = (chosenRequest, index) => {
        const { choices, input, optionValue } = this.props;

        let value = null;

        if (~index) {
            value = choices[index][optionValue];
        }

        return input.onChange(value);
    }

    getSuggestion(choice) {
        const { optionText } = this.props;

        return (typeof optionText === 'function') ? optionText(choice) : choice[optionText];
    }

    onBlur = (event) => {
        const { input } = this.props;

        /**
         * We only want to trigger blur this selector when the input value has changed to an empty string.
         * In all the other cases, we want keep the typed data in the input field.
         */
        if (event.target.value === '') {
            input.onBlur(event.target.value);
        }
    }

    render() {
        const {
            animated,
            choices,
            filter,
            fullWidth,
            hintText,
            input: {
                name,
                value,
            },
            label,
            meta: {
                error,
                touched,
            },
            optionValue,
            resource,
            style,
            translate,
        } = this.props;

        const selectedSource = utils.find(choices, (choice) => {
            return choice[optionValue] === value;
        });

        const dataSource = utils.map(choices, (choice) => {
            return {
                value: choice[optionValue],
                text: this.getSuggestion(choice),
            };
        });

        return (
            <AutoComplete
                animated={ animated }
                dataSource={ dataSource }
                errorText={ touched && error }
                filter={ filter }
                floatingLabelFixed={ !!selectedSource }
                floatingLabelText={ <FieldTitle label={ label } source={ name } resource={ resource } /> }
                fullWidth={ fullWidth }
                id={ name }
                onBlur={ this.onBlur }
                onNewRequest={ this.handleNewRequest }
                onUpdateInput={ (searchText, dataSource, params) => {
                    if (utils.isUndefined(this.props.setFilter)) {
                        return this.handleNewRequest(null, -1);
                    }

                    const { optionText, setFilter } = this.props;

                    setFilter(searchText, dataSource, params, optionText);
                } }
                hintText={ hintText ? hintText : translate('components.autocomplete.hinttext') }
                menuStyle={ {
                    maxHeight: '500px',
                    width: '100%',
                    overflowY: 'auto',
                    touchAction: 'none',
                } }
                openOnFocus={ true }
                searchText={ selectedSource && this.getSuggestion(selectedSource) }
                style={ style }
            />
        );
    }
}

RenderAutoCompleteInputField.defaultProps = {
    animated: true,
    choices: [],
    filter: AutoComplete.fuzzyFilter,
    fullWidth: false,
    optionText: 'name',
    optionValue: 'id',
};

RenderAutoCompleteInputField.propTypes = {
    animated: PropTypes.bool,
    choices: PropTypes.arrayOf(PropTypes.object),
    filter: PropTypes.func,
    fullWidth: PropTypes.bool,
    hintText: PropTypes.string,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        value: PropTypes.value,
    }).isRequired,
    label: PropTypes.string,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    optionText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    optionValue: PropTypes.string,
    resource: PropTypes.string,
    setFilter: PropTypes.func,
    style: PropTypes.object,
    translate: PropTypes.func,
};

export default translate(RenderAutoCompleteInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderAutoCompleteInputField.js